"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluExtractionPayloadSchema = exports.PLU_EXTRACTION_QUEUE = exports.PLU_EXTRACTION_VERSION = void 0;
const zod_1 = require("zod");
// #308 — l'extraction d'un règlement PLU, une fois par PDF.
//
// Le worker `plu_content_extraction` lance les cinq blocs d'extraction
// d'`explore` (texte, pages illisibles, OCR, fusion, paragraphes) et garde ce
// qu'ils produisent en base ; l'analyse d'une étude le relit au lieu de repayer
// l'OCR. Deux producteurs : la collecte des pièces d'une étude (jobs), qui
// accroche l'extraction à l'analyse comme un job enfant, et la CLI `pipeline:*`
// (backend). Voir docs/technical/plu-extraction-partagee.md.
/**
 * La version du code d'extraction. Une extraction gardée sous une autre version
 * n'est jamais relue. Elle monte quand le code des cinq blocs change : un test
 * de `jobs` (`extraction-version.test.ts`) en garde l'empreinte et échoue tant
 * qu'elle n'a pas monté.
 */
exports.PLU_EXTRACTION_VERSION = '2.1.0';
exports.PLU_EXTRACTION_QUEUE = 'plu_content_extraction';
/**
 * Une pièce déposée par la collecte (`files.id`), ou une course de la CLI sur un
 * document enregistré. Les clés inconnues sont écartées, pas refusées : le
 * producteur y glisse la trace Sentry (`__sentry`).
 */
exports.PluExtractionPayloadSchema = zod_1.z.union([
    zod_1.z.object({ fileId: zod_1.z.string().uuid() }),
    zod_1.z.object({ runId: zod_1.z.string().uuid(), documentId: zod_1.z.string().uuid() }),
]);
//# sourceMappingURL=pluExtraction.js.map